import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { AccessDenied } from '../../../../components/ui/access-denied';
import { useAccessControl } from '../../../../hooks/useAccessControl';
import EntityServicesModule from '../../../../modules/fantasy/entity-services';
export const Route = createFileRoute('/dashboard/fantasy/entity-services/')({
  validateSearch: z.object({
    sportType: z.enum(['cricket', 'football']).optional(),
    status: z.enum(['live', 'upcoming']).optional(),
    page: z.number().optional(),
    perPage: z.number().optional(),
  }),
  component: EntityServicesPage,
});
function EntityServicesPage() {
  const { canAccessEntityServices } = useAccessControl();
  if (!canAccessEntityServices) {
    return <AccessDenied />;
  }
  return <EntityServicesModule />;
}
